<div class="d-flex">
    <div class="left-container">
        <div class="table-responsive">
            <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Product</th>
                    <th scope="col">Price</th>
                    <th scope="col">Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">
                        <div class="d-flex">
                            <div class="image-container">
                                <img src="assets/latest/product.svg" alt="" srcset="">
                            </div>
                        </div>
                      
                    </th>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>&#64;mdo</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Jacob</td>
                    <td>Thornton</td>
                    <td>&#64;fat</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Larry</td>
                    <td>the Bird</td>
                    <td>&#64;twitter</td>
                  </tr>
                </tbody>
              </table>
        </div>
       
    </div>
    <div class="right-container"></div>
</div>
